import React from 'react'
import Label from '../../../Form/Label'

const MoreImages = ({
    formData,
    setFormData,
    sizeGuide,
    sampleGuide,
    loadingState,
    handleImageChange,
    handelDeleteImages
}) => {
  return (
    <main className="flex w-full justify-between gap-6">
     <div className="bg-white h-fit  flex flex-col gap-3 rounded-[10px] p-[30px] w-[42%]">
        <div className="text-customGreen  text-[17px] mb-4 font-semibold">
          Section Layout
        </div>
        <img
          src={sampleGuide.moreImages}
          className="w-full"
          alt="Header and Hero Preview"
        />
      </div>
      <div className="bg-white overflow-x-auto min-h-72 rounded-[10px] p-[30px] flex-1">
        <div className="flex items-center justify-between flex-1 mb-8">
          <div className="text-customGreen text-[17px] font-semibold  ">
          More Image Section
          </div>

          <div className="flex ">
            <label className="inline-flex mb-5 cursor-pointer">
            
            <input
                      type="checkbox"
                      checked={formData.gallery.enable}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          gallery: {
                            ...formData.gallery,
                            enable: e.target.checked,
                          },
                        })
                      }
                      className="sr-only peer"
                    />
                    <div className="relative w-9 h-5 bg-red-500 rounded-full peer-checked:bg-emerald-600 after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border after:rounded-full after:h-4 after:w-4 after:transition-all peer-checked:after:translate-x-full" />
                  </label>
                    
          </div>
        </div>
            <div className="flex flex-col gap-3">
              {/* <div className="flex justify-between gap-2">
                <Label label={"Enable This Section"} />
                <div className="flex w-[75%]">
                  <label className="inline-flex mb-5 cursor-pointer">
                    <input
                      type="checkbox"
                      checked={formData.gallery.enable}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          gallery: {
                            ...formData.gallery,
                            enable: e.target.checked,
                          },
                        })
                      }
                      className="sr-only peer"
                    />
                    <div className="relative w-9 h-5 bg-red-500 rounded-full peer-checked:bg-emerald-600 after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border after:rounded-full after:h-4 after:w-4 after:transition-all peer-checked:after:translate-x-full" />
                  </label>
                </div>
              </div> */}
              <div className="flex justify-between gap-2">
                <Label label={"Section Title"} />
                <div className="flex items-center justify-center w-[75%]">
                  <input
                    type="text"
                    placeholder="Enter section title"
                    value={formData.gallery.title}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        gallery: { ...formData.gallery, title: e.target.value },
                      })
                    }
                    maxLength={50}
                    className="w-full px-4 py-2 bg-slate-100 border-solid border-slate-300 text-gray-700 border rounded-md shadow-sm focus:outline-none"
                  />
                </div>
              </div>
              <div className="flex justify-between gap-2">
                <Label label={"Images"} />
                <div className="flex flex-col items-center justify-center w-[75%]">
                  <label
                    htmlFor="MoreImages"
                    className="flex flex-col items-center justify-center w-full h-40 border-2 border-customGreen border-dashed rounded-lg cursor-pointer bg-gray-50 hover:bg-gray-100"
                  >
                    <div className="flex flex-col items-center justify-center pt-5 pb-6">
                      <svg
                        className="w-8 h-8 mb-4 text-customGreen"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 20 16"
                      >
                        <path
                          stroke="currentColor"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2"
                        />
                      </svg>
                      <p className="mb-2 text-sm text-gray-500">
                        <span className="font-semibold">Click to upload</span>{" "}
                        or drag and drop
                      </p>
                      <p className="text-xs text-gray-500">
                        PNG, SVG, WebP, JPG or JPEG and Recommended size:{" "}
                        {sizeGuide?.moreImages || "Max 800x400px"}
                      </p>
                    </div>
                    <input
                      id="MoreImages"
                      type="file"
                      className="hidden"
                      disabled={loadingState.sectionMore}
                      onChange={(e) => handleImageChange(e, "sectionMore")}
                    />
                  </label>
                  {loadingState.sectionMore && (
                    <div className="loading-container flex flex-col items-center mt-4">
                      <div className="spinner"></div>
                      <p className="text-sm text-gray-600 mt-2">
                        Uploading image, please wait...
                      </p>
                    </div>
                  )}
                  {formData.gallery.images.length > 0 &&
                    !loadingState.sectionMore && (
                      <div className="mt-4 flex gap-2">
                        {formData.gallery.images.map((image, index) => (
                          <div key={index} className="relative">
                            <img
                              src={image}
                              alt={`Gallery Preview ${index + 1}`}
                              className="w-16 h-16 rounded-lg shadow-md"
                            />
                            <button
                              className="absolute top-0 right-0 text-red-500 bg-white rounded-full p-1 shadow-md"
                              onClick={() =>
                                handelDeleteImages(image, "sectionMore")
                              }
                            >
                              X
                            </button>
                          </div>
                        ))}
                      </div>
                    )}
                </div>
              </div>
            </div>
          </div>
    </main>
  )
}

export default MoreImages
